import { Button } from "@material-ui/core";
import PropTypes from "prop-types";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

interface BtnProps {
  onClick: () => void;
  [key: string]: any;
  label?: string;
}

const CancelButton: FC<BtnProps> = ({ onClick, label, ...others }) => {
  const { t } = useTranslation();

  return (
    <Button
      color="primary"
      sx={{ mt: 1 }}
      variant="outlined"
      onClick={onClick}
      className="commanBtnStyle"
      {...others}
      
    >
      {t(label) || t("Cancel")}
    </Button>
  );
};

CancelButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default CancelButton;
